import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	undoLabel: {
		id: 'project-details.undo-label',
		defaultMessage: 'Undo',
		description: 'Undo button label',
	},
	moreInfoLabel: {
		id: 'project-details.more-info-label',
		defaultMessage: 'More about project keys',
		description: 'A link to more information about project keys',
	},
	warningLabel: {
		id: 'project-details.warning-label',
		defaultMessage:
			'Once you save this change, any links, filters and queries using your previous keys will no longer work',
		description: 'A warning label about the risks of releasing project keys',
	},
});
